<template>
  <div class="changeColor containerLedger test">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="添加试题" name="first">
        <div class="content" :style="{height:height+'vh'}" v-if="activeName == 'first'">
          <div style="text-align: right;padding: 20px 20px 0 0">
            <el-button type="success"><a
              href="./questionTemplate.xls"
              download="questionTemplate.xls"
              style="font-size: 14px; cursor: pointer;color: #fff"
            >下载导入模板</a
            ></el-button>
            <el-button type="success" @click="importsClick">试题批量导入</el-button>
          </div>
          <test ref='content'></test>
          <resourcesUpload ref='resourcesUpload'></resourcesUpload>
          <el-col :span="24">
            <div class="button">
              <el-button @click="clearData">清空</el-button>
              <el-button type="primary" @click="submit">提交</el-button>
            </div>
          </el-col>
        </div>
        <div>
          <el-dialog
            title="批量导入"
            :visible.sync="dialogVisibleImport"
            width="70%"
            >
            <ImportTest v-if="dialogVisibleImport" @successClose="dialogVisibleImport=false"></ImportTest>
          </el-dialog>
        </div>
      </el-tab-pane>
      <el-tab-pane label="试题列表" name="second" class="user_list">
        <resourceList v-if="activeName == 'second'"></resourceList>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import resourceList from '@/views/testManagement/list/resource';
import resourcesUpload from './resourcesUpload';
import test from '@/views/testManagement/test';
import ImportTest from './imports/ImportTest'
export default {
  name: 'testIndex',
  components: {
    test,
    resourcesUpload,
    resourceList,
    ImportTest
  },
  data() {
    return {
      dialogVisibleImport:false,
      activeName: 'first',
      height: 80,
      searchData: {
        resource_type: 4,//资源类型选中的值
        resource_id: '',
        is_public: 0,
        thumbnail: '',
        ico_file_bucket: '',
        file_bucket: '',
        fenbianlv: '',
        file_origin: '',
        file_size: '',
        value_array: [],
      },//收集页面数据
    };
  },
  mounted() {
  },
  methods: {
    handleClose(){},
    handleClick() {
    },
    clearData() {
      this.$refs.resourcesUpload.clearData();
      this.$refs.content.clearData();
    },
    submit() {
      let data = this.$refs.resourcesUpload.searchData.zsdName;
      this.searchData.value_array = [];
      if (data.length > 0) {
        data.forEach(element => {
          let json = {};
          json['node_id'] = element;
          this.searchData.value_array.push(json);
        });
      }
      this.$refs.content.submit();
      let searchData = JSON.parse(JSON.stringify(this.searchData));
      let jsons = Object.assign(searchData, this.$refs.content.searchData);
      // console.log(jsons);
      // if(!jsons.thumbnail && jsons.resource_type != 4){
      //   this.$message.warning("请上传封面")
      // }else if(!jsons.file_origin && jsons.resource_type != 1  && jsons.resource_type != 4
      //   &&  jsons.resource_type != 7 &&  jsons.resource_type != 8 &&  jsons.resource_type != 9
      //   &&  jsons.resource_type != 12 &&  jsons.resource_type != 14){
      //   this.$message.warning("请上传文件")
      // }else{
      // console.log(1111,jsons)
      if(jsons.resource_type == 4){
        if(jsons.name == ''){
          this.$message.error('请填写题干')
          return
        }else if(jsons.options.length <= 1){
          this.$message.error("选项至少两个")
          return
        }else if(jsons.answer == 0){
          this.$message.error("请勾选正确答案")
          return
        }else {
          this.$post(this.$api.resourceAdd, jsons)
            .then(res => {
              if (res.code === 0) {
                this.$message.success('提交成功');
                this.clearData();
              }
            });
        }
      }




      // }
      // 	this.$post(this.$api.resourceAdd,jsons).then(res => {
      // 		if(res.code === 0){
      // 			this.$message.success('提交成功');
      // 			this.clearData()
      // 		}
      // 	})
    },
    //点击批量导入
    importsClick(){
      this.dialogVisibleImport = true
    },
  }
};
</script>

<style scoped>
.test >>> .el-tabs__content {
  height: 80vh
}

.content {
  overflow-y: auto;
}

.button {
  overflow: hidden;
  text-align: center;
  width: 100%;
  margin-bottom: 20px;
}

</style>
